<a class="dropdown-toggle" [attr.aria-describedby]="notifiche.length > 0 ? 'info-notifiche' : 'no-notifiche'" data-toggle="dropdown" [attr.aria-label]="numeroNotificheTotali ? numeroNotificheTotali: notifiche.length" appTooltip="Notifiche" placement="bottom" [appTooltipEnabled]="true"
    (click)="onClick.emit($event)" href="#" role="button" aria-haspopup="true" aria-expanded="false">
    {{numeroNotificheTotali ? numeroNotificheTotali: notifiche.length}}
</a>
<div class="dropdown-menu">
    <h2>Notifiche</h2>

    <div *ngIf="notifiche.length > 0" class="alert_content">
        <ul notifiche-list class="notifiche" [notifiche]="notifiche" [slice]="numToView"></ul>
        <small id="info-notifiche" class="sr-only">
            Sono presenti {{notifiche.length}} notifiche
        </small>
    </div>
    <div *ngIf="notifiche.length == 0">
        <p class="allinea_centro">Non ci sono notifiche</p>
        <small id="no-notifiche" class="sr-only">
            Non ci sono notifiche
        </small>
    </div>
    <div class="read_more">
        <a appTooltip="Vedi tutte le notifiche" [appTooltipEnabled]="true"
            [routerLink]="['/',viewAllNotifiche]">
            Vedi tutti
        </a>
    </div>
</div>
